var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProblem4 = function SvgProblem4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 132,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__a)",
    fillRule: "evenodd",
    d: "M6.958 41.698c-2.553 0-4.623 2.061-4.623 4.604s2.07 4.605 4.623 4.605 4.623-2.062 4.623-4.605-2.07-4.604-4.623-4.604M0 46.302c0-3.827 3.115-6.93 6.958-6.93s6.958 3.103 6.958 6.93c0 3.828-3.115 6.93-6.958 6.93S0 50.13 0 46.303",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__b)",
    fillRule: "evenodd",
    d: "M46.488 41.698c-2.553 0-4.623 2.061-4.623 4.604s2.07 4.605 4.623 4.605 4.623-2.062 4.623-4.605-2.07-4.604-4.623-4.604m-6.958 4.604c0-3.827 3.115-6.93 6.958-6.93s6.958 3.103 6.958 6.93c0 3.828-3.115 6.93-6.958 6.93s-6.958-3.102-6.958-6.93",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__c)",
    fillRule: "evenodd",
    d: "M40.698 49.558h-27.95v-6.511h27.95z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__d)",
    fillRule: "evenodd",
    d: "M6.958 81.093c-2.553 0-4.623 2.062-4.623 4.605s2.07 4.604 4.623 4.604 4.623-2.061 4.623-4.604-2.07-4.605-4.623-4.605M0 85.698c0-3.828 3.115-6.93 6.958-6.93s6.958 3.102 6.958 6.93-3.115 6.93-6.958 6.93S0 89.525 0 85.698",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__e)",
    fillRule: "evenodd",
    d: "M46.488 81.093c-2.553 0-4.623 2.062-4.623 4.605s2.07 4.604 4.623 4.604 4.623-2.061 4.623-4.604-2.07-4.605-4.623-4.605m-6.958 4.605c0-3.828 3.115-6.93 6.958-6.93s6.958 3.102 6.958 6.93-3.115 6.93-6.958 6.93-6.958-3.103-6.958-6.93",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__f)",
    fillRule: "evenodd",
    d: "M40.698 88.954h-27.95v-6.512h27.95z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__g)",
    fillRule: "evenodd",
    d: "M10.227 52.093v27.814H3.689V52.093z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__h)",
    fillRule: "evenodd",
    d: "M86.042 120.465c-2.553 0-4.623 2.062-4.623 4.605s2.07 4.604 4.623 4.604 4.623-2.061 4.623-4.604-2.07-4.605-4.623-4.605m-6.958 4.605c0-3.828 3.115-6.93 6.958-6.93S93 121.242 93 125.07 89.885 132 86.042 132s-6.958-3.103-6.958-6.93",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__i)",
    fillRule: "evenodd",
    d: "M89.31 91.465v27.837h-6.537V91.465z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__j)",
    fillRule: "evenodd",
    d: "M49.757 52.093v27.814H43.22V52.093z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__k)",
    fillRule: "evenodd",
    d: "M86.042 41.698c-2.553 0-4.623 2.061-4.623 4.604s2.07 4.605 4.623 4.605 4.623-2.062 4.623-4.605-2.07-4.604-4.623-4.604m-6.958 4.604c0-3.827 3.115-6.93 6.958-6.93S93 42.475 93 46.302c0 3.828-3.115 6.93-6.958 6.93s-6.958-3.102-6.958-6.93",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__l)",
    fillRule: "evenodd",
    d: "M80.228 49.558H52.302v-6.511h27.926z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__m)",
    fillRule: "evenodd",
    d: "M86.042 81.093c-2.553 0-4.623 2.062-4.623 4.605s2.07 4.604 4.623 4.604 4.623-2.061 4.623-4.604-2.07-4.605-4.623-4.605m-6.958 4.605c0-3.828 3.115-6.93 6.958-6.93S93 81.87 93 85.697s-3.115 6.93-6.958 6.93-6.958-3.103-6.958-6.93",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__n)",
    fillRule: "evenodd",
    d: "M80.228 88.954H52.302v-6.512h27.926z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__o)",
    fillRule: "evenodd",
    d: "M89.31 52.093v27.814h-6.537V52.093z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__p)",
    fillRule: "evenodd",
    d: "M6.958 2.326c-2.553 0-4.623 2.061-4.623 4.604s2.07 4.605 4.623 4.605 4.623-2.062 4.623-4.605-2.07-4.604-4.623-4.604M0 6.93C0 3.103 3.115 0 6.958 0s6.958 3.103 6.958 6.93c0 3.828-3.115 6.93-6.958 6.93S0 10.759 0 6.93",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_4_svg__q)",
    fillRule: "evenodd",
    d: "M10.227 12.698v27.837H3.689V12.698z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__a",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__b",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__c",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__d",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__e",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__f",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__g",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__h",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__i",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__j",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__k",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__l",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__m",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__n",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__o",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__p",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_4_svg__q",
    x1: 46.5,
    x2: 46.5,
    y1: 0,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
};
export default SvgProblem4;